import { memo } from 'react'

const StopIcon: React.FC = memo(() => (
  <svg
    fill="#ffffff"
    width="20px"
    height="20px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.92 24.096q0 0.832 0.576 1.408t1.44 0.608h16.128q0.832 0 1.44-0.608t0.576-1.408v-16.16q0-0.832-0.576-1.44t-1.44-0.576h-16.128q-0.832 0-1.44 0.576t-0.576 1.44v16.16z" />
  </svg>
))

export { StopIcon }
